import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { TaoUsersArgs, TaoUser } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { buildApiUrl } from "@/utils/api";

const getTaoUser = async (params: TaoUsersArgs) => {
  // @eslint-disable-line
   const { data } = await tokenAxios().get<TaoUser>(buildApiUrl("taoUser"), { params });
  return data;
};

export const useTaoUser = () => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;


  return useQuery<TaoUser, Error>({
    queryKey: ["Tao-Routing-User", practiceId, requestedUser],
    queryFn: () => getTaoUser({ practiceId, requestedUser }),
  });
};
